/**
 * 房间信息
 */
import React, { memo } from 'react';
import { connect } from 'react-redux';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import intl from 'react-intl-universal';
import InputWithCoupon from '@/components/Reservation/NumberInput/InputWithCoupon';
import { createStateSelector } from '@/redux/actions/reservation/helper';
import { updateInvoiceAmount } from '@/redux/actions/bill/invoice';
import { ReducerState, storeName } from '@/redux/reducers/bill/invoice';
import { format2Decimal, parseFen2Currency } from '@/utils/number';
import { orderTypeMap, OrderTypeEnum } from '../../constant';
import styles from './index.module.scss';

const stateSelector = (state: ReducerState) => {
  const { orderList } = state;
  return { orderList };
};
const mapStateToProps = createStateSelector<ReducerState>(storeName, stateSelector);
const mapDispatchToProps = {
  invoiceAmountChange: updateInvoiceAmount,
};

type MapStateProps = ReturnType<typeof stateSelector>;
type MapDispatchProps = typeof mapDispatchToProps;

interface IProps {
  isView: boolean; // 是否是仅预览模式
}

const Index: React.FC<IProps & MapStateProps & MapDispatchProps> = ($$) => {
  const renderPriceItem: (value: string, record: any) => React.ReactNode = (value, record) => {
    if ($$.isView) return format2Decimal(value);
    return (
      <InputWithCoupon
        withCoupon={false}
        value={value}
        onChange={(val: any) => $$.invoiceAmountChange(val, record.orderNo)}
      />
    );
  };

  const tableColumns: ColumnsType<any> = [
    { title: intl.get('bill_invoice_modal_order_no'), dataIndex: 'orderNo', key: 'orderNo' },
    {
      title: intl.get('bill_invoice_modal_order_type'),
      dataIndex: 'orderType',
      key: 'orderType',
      render: (val) => {
        return orderTypeMap[val] || '-';
      },
    },
    { title: intl.get('bill_invoice_modal_room'), dataIndex: 'roomNo', key: 'roomNo' },
    {
      title: intl.get('bill_invoice_modal_guest'),
      dataIndex: 'name',
      key: 'name',
      render: (val, record) => {
        if (
          record.orderType === OrderTypeEnum.receptionGoods ||
          record.orderType === OrderTypeEnum.receptionConsume
        )
          return '-';
        return val;
      },
    },
    {
      title: intl.get('bill_invoice_modal_available_amt'),
      dataIndex: 'availableAmt',
      key: 'availableAmt',
      render: (val) => {
        return parseFen2Currency(val);
      },
    },
    {
      title: intl.get('bill_invoice_modal_invoiced_amt'),
      dataIndex: 'invoicedAmt',
      key: 'invoicedAmt',
      render: (val) => {
        return parseFen2Currency(val);
      },
    },
    {
      title: intl.get('bill_invoice_modal_consume_amt'),
      dataIndex: 'consumeAmt',
      key: 'consumeAmt',
      render: (val) => {
        return parseFen2Currency(val);
      },
    },
    {
      title: intl.get('bill_invoice_modal_operator_name'),
      dataIndex: 'operatorName',
      key: 'operatorName',
      render: (_val, record) => {
        if (record.orderType === OrderTypeEnum.goodsSelfService)
          return intl.get('bill_invoice_modal_customer');
        return `${record.updateBy || ''}${record.operatorName || ''}`;
      },
    },
    {
      title: intl.get('bill_invoice_modal_this_invoice_amount'),
      dataIndex: 'invoiceAmount',
      key: 'invoiceAmount',
      align: 'right',
      render: (value, record) => renderPriceItem(value, record),
    },
  ];

  return (
    <Table
      pagination={false}
      className={styles.invoiceOrderList}
      rowKey="orderNo"
      columns={tableColumns}
      dataSource={$$.orderList || []}
    />
  );
};

export default connect<MapStateProps, MapDispatchProps, IProps>(
  mapStateToProps,
  mapDispatchToProps,
)(memo(Index));
